"use client";

import React from "react";
import { Button } from "../common/button";

export interface Step {
  number: string;
  title: string;
  description: string;
}

export interface HowItWorksProps {
  title?: string;
  steps?: Step[];
  ctaText?: string;
  onCtaClick?: () => void;
  showCta?: boolean;
}

export function HowItWorks({
  title = "How Alli Works",
  steps = [
    {
      number: "1",
      title: "Browse therapists",
      description: "Filter by speciality, availability, price and more to find your match"
    },
    {
      number: "2", 
      title: "Book a session",
      description: "Select a time that works for you and book directly with the therapist"
    },
    {
      number: "3",
      title: "Start therapy",
      description: "Connect via secure video from anywhere in Canada"
    }
  ],
  ctaText = "Browse all therapists",
  onCtaClick,
  showCta = true
}: HowItWorksProps) {
  return (
    <section className="py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">{title}</h2>
        
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary-600">{step.number}</span>
              </div>
              <h3 className="font-semibold text-lg mb-2">{step.title}</h3>
              <p className="text-gray-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>
        
        {showCta && (
          <div className="text-center">
            <Button variant="outline" size="lg" onClick={onCtaClick}>
              {ctaText}
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}